import React from 'react'

function TenderTextWallslot() {
    return (
        <embed src="\pdfs\EAT1.2.8_WSD_Wall_slot_diffuser_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextWallslot